<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :actions="actions"
      :title="title"
      :beforeSetupGrid="beforeSetupGrid"
      ref="grid"
      :selectionEnabled="false"
    ></dx-grid>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.title,
    };
  },
  data: () => ({
    url: "",
    title: "ManageEngine Technicians",
    actions: [],
    columns: [
      {
        label: "Id",
        field: "id",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Name",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Email",
        field: "emailID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  created() {
    this.actions.push({
      text: "Sync Technicians",
      action: this.syncTechnicians,
    });
    this.actions.push({
      text: "Edit Technicians on ManageEngine",
      action: this.openManageEngineSite,
    });
  },
  methods: {
    async syncTechnicians() {
      try {
        const response = await this.$http.post(
          "api/ManageengineTechnicians/SyncManageengineTechnicians"
        );
      } catch (error) {
        this.$notify({
          group: "notification",
          text: "Error syncing technicians",
          type: "error",
        });
      }
      this.$refs.grid.reloadGrid();
      this.$notify({
        group: "notification",
        text: "Technicians synced successfully",
        type: "success",
      });
      return response;
    },

    openManageEngineSite() {
      window.open(
        "https://utaw.sdpondemand.manageengine.com/app/itdesk/AdminDetails.cc?forwardTo=technician",
        "_blank"
      );
    },
    async beforeSetupGrid() {
      this.url = `ManageengineTechnicians`;
    },
  },
};
</script>
